import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import katalMetricsPublisher from 'src/utils/metrics';
import { TimerStopwatch } from '@amzn/katal-metrics/lib/metricObject';

function NavigationMetrics() {
	const location = useLocation();
	let publishFinalMetric = () => {};

	// Intercept any location or URL changes for logging
	useEffect(() => {
		const path = location.pathname;

		const childPublisher =
			katalMetricsPublisher.newChildActionPublisherForMethod(
				`Navigation.${normalizePathname(path)}`
			);

		childPublisher.publishCounterMonitor('visit', 1);
		const timer = new TimerStopwatch('visitLength').withMonitor(true);

		// the JSON driver doesn't have a beforeUnload method
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		if ((katalMetricsPublisher as any).driver.beforeUnload) {
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
			(katalMetricsPublisher as any).driver.beforeUnload(() => {
				publishFinalMetric();
			});
		}

		publishFinalMetric = () => {
			// Publish when location changes
			childPublisher.publish(timer);
		};

		return publishFinalMetric;
	}, [location]);

	return <></>;
}

/**
 * Strip leading and trailing slashes, convert slashes to dots, and lowercase.
 */
export const normalizePathname = (pathname: string) =>
	pathname
		.replace(/^\/?(.*?)\/?$/, '$1')
		.replace(/\//g, '.')
		.toLowerCase();

export default NavigationMetrics;
